import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PAGE_URL = {
  B2C_LANDING_PAGE: '/b2c-logistics',
  B2B_LANDING_PAGE: '/b2b-logistics',
  INTERNATIONAL_LANDING_PAGE: '/international-logistics',
  THIRD_PARTY_LANDING_PAGE: '/third-party-logistics',
};

export const LANGUAGES = {
  en: 'English',
};

export const DEVICE_SIZES = {
  tablet: 768,
  laptop: 992,
  desktop: 1200,
};

export const DEVICE_TYPE = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  LAPTOP: 'LAPTOP',
  DESKTOP: 'DESKTOP',
};

export const DEVICES = {
  sSMobile: `(max-width: 380px)`,
  sMobile: `(max-width: 480px)`,
  mobile: `(max-width: ${DEVICE_SIZES.tablet}px)`,
  tablet: `(min-width: ${DEVICE_SIZES.tablet}px) and (max-width:${DEVICE_SIZES.laptop}px)`,
  laptop: `(min-width: ${DEVICE_SIZES.laptop}px) and (max-width:${DEVICE_SIZES.desktop}px)`,
  desktop: `(min-width: ${DEVICE_SIZES.desktop}px)`,
};

export const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
